import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from './Layout';

const PrivacyPage = () => {
  return (
    <Layout breadcrumbItems={[
      { label: 'Home', href: '/' },
      { label: 'Privacy Policy', href: '/privacy' }
    ]}>
      <Helmet defer={false}>
        <title>Privacy Policy - Free Google SERP Checker</title>
        <meta name="description" content="Privacy Policy for our free Google SERP checker tool. Learn how we collect, use, and protect your data." />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Privacy Policy - Free Google SERP Checker" />
        <meta property="og:description" content="Privacy Policy for our free Google SERP checker tool. Learn how we collect, use, and protect your data." />
        <meta property="og:url" content="https://freeserpchecker.org/privacy" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Privacy Policy - Free Google SERP Checker" />
        <meta name="twitter:description" content="Privacy Policy for our free Google SERP checker tool. Learn how we collect, use, and protect your data." />
      </Helmet>
      
      <div className="bg-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
            
            <div className="space-y-6 text-gray-700">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>
                <p className="mb-4">
                  We collect information you provide directly to us, such as when you use our SERP checker tool. 
                  This may include search queries, location data, and usage analytics.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Your Information</h2>
                <p className="mb-4">
                  We use the information we collect to provide, maintain, and improve our services, 
                  to develop new features, and to protect our users.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Information Sharing</h2>
                <p className="mb-4">
                  We do not sell, trade, or otherwise transfer your personal information to third parties 
                  without your consent, except as described in this policy.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Security</h2>
                <p className="mb-4">
                  We implement appropriate security measures to protect your personal information 
                  against unauthorized access, alteration, disclosure, or destruction.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Cookies and Tracking</h2>
                <p className="mb-4">
                  We use cookies and similar tracking technologies to enhance your experience 
                  and collect usage information. You can control cookie settings through your browser.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Third-Party Services</h2>
                <p className="mb-4">
                  We may use third-party services for analytics and functionality. 
                  These services have their own privacy policies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Your Rights</h2>
                <p className="mb-4">
                  You have the right to access, correct, or delete your personal information. 
                  Contact us to exercise these rights.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Changes to This Policy</h2>
                <p className="mb-4">
                  We may update this privacy policy from time to time. 
                  We will notify you of any changes by posting the new policy on this page.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact Us</h2>
                <p className="mb-4">
                  If you have any questions about this privacy policy, 
                  please contact us at privacy@freeserpchecker.org
                </p>
              </section>

              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-sm text-gray-500">
                  Last updated: January 2025
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPage;
